module.exports = __webpack_public_path__ + "img/pp-55.897f31bb.jpg";